import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  generateHashRequest: [],
  generateHashSuccess: ['hmac'],
  generateHashFailure: ['error'],

  generateAccessTokenRequest: ['hash'],
  generateAccessTokenSuccess: ['accessToken'],
  generateAccessTokenFailure: ['error'],

  getGeoLocationRequest: [],
  getGeoLocationSuccess: ['geoLocationCoordinates'],
  getGeoLocationFailure: ['error'],

  getGymHoursRequest: ['gymId'],
  getGymHoursSuccess: ['gymHoursData'],
  getGymHoursFailure: ['error'],
});

const Actions = {
  Types,
  Creators,
};

export default Actions;
